import type { SxProps, Theme } from '@mui/material/styles';

export const getHoverableItemStyles = (params: {
  readOnly: boolean;
  isNested?: boolean;
}): Record<string, SxProps<Theme>> => ({
  root: () => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    zIndex: 0,

    ...(!params.readOnly && {
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: params.isNested ? -5 : -3,
        right: -3,
        zIndex: -1,
        pointerEvents: 'none',
      },

      '&:hover::before': {
        backgroundColor: 'background.default',
      },

      '&:hover .hoverable': {
        visibility: 'visible',
      },
    }),
  }),

  iconBox: {
    mr: 1.5,
    display: 'flex',
    alignItems: 'center',
  },

  contentBox: {
    flexGrow: 1,
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
  },

  hoverableBox: {
    visibility: 'hidden',
  },

  closeButton: {
    ml: 1,
  },
});
